import React from "react";
import "./style.css";
import { ReactComponent as SuperVisorLogo } from "../../../../assets/images/supervisorlogo.svg";
import { Avatar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { assignTicketToSelf } from "../../../../store/features/assignTicketToSelf";
import { getTicketMessagesById } from "../../../../store/features/getTicketMessagesById";
import {  chracterPosition } from "../../../../utils/index";
import { colorCodesForAvatar } from "../../../../constants/index";
import { toast } from "react-toastify";

function AssigneTicket(props) {
  const { assignee, isAgent, ticketId, setShowAssignPopup } = props;
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken?.response?.user);
  const { loading } = useSelector((state) => state.assignTicketToSelf);

  const handleAssignToSelf = async () => {
    if ( loading) return;

    try {
      await dispatch(
        assignTicketToSelf({
          ticketId,
          businessId: userData.business_id,
          agentId: userData._id,
        })
      ).unwrap();

      await dispatch(getTicketMessagesById(ticketId)).unwrap()

      toast.success("Ticket assigned successfully");
    } catch (error) {
      console.error("Failed to assign ticket:", error);
      toast.error("Failed to assign ticket");
    }
  };

  const handleChangeClick = () => {
    if (setShowAssignPopup) setShowAssignPopup(true);
  };

  const handleAddAssigneeClick = () => {
    if (setShowAssignPopup) setShowAssignPopup(true);
  };

  return (
    <div className="SuperVisor-Main-Container">
      <>
        <div className="SuperVisor-Header-text">
          <p className="SuperVisorText">{"Assignee"}</p> 
          <p
            className="SuperVisorChange"
            onClick={
              assignee
                ? handleChangeClick
                : isAgent
                ? handleAssignToSelf
                : handleAddAssigneeClick // <-- open handler when add assignee
            }
            style={{
              cursor:
                assignee && !isAgent
                  ? "pointer"
                  : !assignee && isAgent
                  ? "pointer"
                  : !assignee && !isAgent
                  ? "pointer"
                  : "pointer",
            }}
          >
            {assignee
              ? "Change"
              : isAgent
              ? "Assign to me"
              : "Add Assignee"}
          </p>
        </div>
        {!assignee && !isAgent && (
          <div className="AssignToMeButton-container">
            <button className="AssignToMeButton" onClick={handleAssignToSelf} style={{ marginTop: "10px" }}>
              Assign to me
            </button>
          </div>
        )}
        {assignee && (
          <div className="SuperVisor-Logo-container">
            {assignee?.agent_image ? (
              <Avatar
                alt={assignee?.full_name}
                src={assignee?.agent_image}
                sx={{ width: 40, height: 40 }}
              />
            ) : (
              <Avatar
              sx={{
                width: 40,
                height: 40,

                bgcolor:
                  colorCodesForAvatar[
                    chracterPosition(
                    assignee.full_name.substring(0,1)
                    )
                  ],
              }}
            >
              {assignee.full_name?.substring(0, 1)?.toUpperCase()}
            </Avatar>
            )}
     
            <div className="Super-Main-text">
              <p className="Super-Robert-text">{assignee?.full_name}</p>
              <p className="Super-Kenzi-text">{assignee?.email}</p>
            </div>
          </div>
        )}
      </>
    </div>
  );
}

export default AssigneTicket;
